import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableRow, Modal, Header } from 'semantic-ui-react';
import getUnapprovedCompanyRecruiters from '../../../../services/getUnapprovedCompanyRecruiters';
import Button from '../../../../components/Button';
import CompanyDropdown from '../../../../components/Dropdown/CompanyDropdown';
import updateCompanyId from '../../../../services/updateCompanyId';
import { getValueFromRecruiterType } from '../../../../models/recruiterType';
import { toast } from 'react-toastify';
import './JobSingleList.scss';
import moment from 'moment';
import { Popup } from 'semantic-ui-react';

const notAvailable = 'N/A';

const JobSingleList = (props) => {
    console.log('props.data', props.data);
    const status = {
        0: 'Pending',
        1: 'Proccessing',
        2: 'Completed',
        3: 'failed',
    }

    return (
        <>
            <TableRow>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.id ? props.data.id : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.rec_email ? props.data.rec_email : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.admin_email ? props.data.admin_email : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.created_at
                        ? moment(props.data.created_at).format('YYYY-MM-DD')
                        : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.status >= 0 ? status[props.data.status] : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.job_ids
                        ? props.data.job_ids.split(',').map((jobId, idx) => (
                            <React.Fragment key={jobId.trim()}>
                                <a
                                    href={`/editjob/${jobId.trim()}`}
                                    target="_blank"
                                >
                                    {jobId.trim()}
                                </a>
                                {idx < props.data.job_ids.split(',').length - 1 && ', '}
                            </React.Fragment>
                        ))
                        : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {
                        (props.data.metaDetails || []).map((i, idx) => (
                            <React.Fragment key={idx}>
                                <span>{i.id}</span> - <span>{
                                    i.published_id ? <a target='_blank' href={`${process.env.REACT_APP_JOBSEEKER_URL}/j/title-${i.published_id}`} >{i.published_id}</a> :
                                        (i.rejected ?
                                            <Popup
                                                trigger={<span>Rejected</span>}
                                                content={i.reject_msg}
                                                inverted disabled={false}
                                            /> :
                                            "Pending")
                                }
                                </span><br />
                            </React.Fragment>
                        ))
                    }
                </Table.Cell>
            </TableRow>
        </>
    );
};


JobSingleList.propTypes = {
    data: PropTypes.object,
    industryData: PropTypes.array,
    executeAccess: PropTypes.bool,
    rejectCompany: PropTypes.func,
    openRecruitersModal: PropTypes.func,
    changeStatus: PropTypes.func,
    onClick: PropTypes.func,
    isRejectedStatus: PropTypes.bool,
    adminId: PropTypes.string.isRequired,
    adminEmail: PropTypes.string.isRequired,
};

export default JobSingleList;
